import { AppProps } from "next/app";
import { Layout } from "@/components/index";
import { ChakraProvider } from "@chakra-ui/provider";
import { AuthProvider } from "@/utils/auth";
import "../styles/main.css";
import theme from "@/styles/theme";
import Head from "next/head";
// export function reportWebVitals(metric) {
//   console.log(metric);
// }
function App({ Component, pageProps }: AppProps) {
  return (
    <AuthProvider>
      <ChakraProvider theme={theme}>
        <Head>
          <meta
            name="viewport"
            content="width=device-width, maximum-scale=5.0"
          />
        </Head>
        <Layout>
          <Component {...pageProps} />
        </Layout>
      </ChakraProvider>
    </AuthProvider>
  );
}

export default App;
